import React from 'react';

interface ArrowLeftIconProps {
  className?: string
}

const ArrowLeftIcon = (props : ArrowLeftIconProps) => {
  return (
    <svg className={props.className} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd"
            d="M10.5553 8.92058L2.92059 8.92057C2.41216 8.92057 2 8.50841 2 7.99998C2 7.49155 2.41216 7.07939 2.92059 7.07939L10.5553 7.07939L9.11385 5.60464C8.76823 5.25102 8.76823 4.68611 9.11385 4.33249C9.47084 3.96724 10.0584 3.96725 10.4154 4.33249L13.5446 7.534C13.7978 7.79306 13.7978 8.2069 13.5446 8.46597L10.4154 11.6675C10.0584 12.0327 9.47084 12.0327 9.11385 11.6675C8.76823 11.3138 8.76823 10.7489 9.11385 10.3953L10.5553 8.92058Z"
            fill="#E0E0E0"/>
    </svg>
  );
};

export default ArrowLeftIcon;